import "../css/style.scss";
import "../css/style_radio.scss";
// // ツイートボタン押下時にテキストを動的に変更してツイート
// function tweet() {
//   // 出力結果を取得
//   var text = (<HTMLInputElement>(
//     document.getElementsByClassName("js_input-text")[0]
//   )).value;
//   // オプションパラメータを設定
//   let hashtags = "縦書き画像メーカー";
//   let url = "https://make-textcard.netlify.app/";  // location.hrefは今いるURL
//   // URLを生成して遷移
//   window.open("https://twitter.com/share?text=" + text + "&hashtags=" + hashtags + "&url=" + url);
// }
var charPosition = /** @class */ (function () {
    // コンストラクタ
    function charPosition(angle, transPosX, transPosY, drawPosX, drawPosY) {
        this.angle = angle;
        this.transPosX = transPosX;
        this.transPosY = transPosY;
        this.drawPosX = drawPosX;
        this.drawPosY = drawPosY;
    }
    return charPosition;
}());
var kotobagaki = "詞書：";
function downloadCardImage() {
    var canvas = document.getElementById("canvas");
    if (canvas) {
        //アンカータグを作成
        var a = document.createElement("a");
        //canvasをJPEG変換し、そのBase64文字列をhrefへセット
        a.href = canvas.toDataURL("image/png");
        //ダウンロード時のファイル名を指定
        var date = new Date();
        var filename = "".concat(date.getFullYear(), "-").concat(("0" +
            (date.getMonth() + 1)).slice(-2), "-").concat(("0" + date.getDate()).slice(-2), ".png");
        a.download = filename;
        //クリックイベントを発生させる
        a.click();
    }
}
function genereteCardImage() {
    drawCanvas();
}
/*
 * @author phi_jp
 */
window.onload = function () {
    drawCanvas();
};
// function chkRotate(text: string, width: number): charPosition {
//   const nums: number[] = [];
//   //無視した記号　→ ¡¿¥℉℃™€‰※‹µ¤∆¶÷×±»«›‡†№§°π√‾≠≒≡≦≧⊂⊃⊆⊇∈∋∪∩⇒⇔
//   if (text.match(/[0-9a-zA-Z]/)) {
//     nums.push(90);
//     nums.push(0);
//     nums.push(2);
//     nums.push(-0.8 * width);
//     nums.push(0);
//     return new charPosition(90, 0, 2, -0.8 * width, 0);
//   }
//   {
//     const kigou = "ー〜～（）=_;~|><}{][＜＞…‥：；｜「」【】『』［］−―／＼";
//     if (kigou.indexOf(text) !== -1)
//       return new charPosition(90, 0, 2, -width, 0);
//   }
//   {
//     const kigou = "、。，．";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(180, 0, 2, -width, 0.8 * width);
//     }
//   }
//   {
//     const kigou = "!";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(0, 0, 0, 0.3 * width, 0);
//     }
//   }
//   {
//     const kigou = "+";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(0, 0, 0, 0.1 * width, 0);
//     }
//   }
//   {
//     const kigou = "-＝";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(90, 0, 0, -width, -0.1 * width);
//     }
//   }
//   {
//     const kigou = "(";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(90, 1, 2, -0.5 * width, -0.1 * width);
//     }
//   }
//   {
//     const kigou = ")";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(90, 1, 2, -0.75 * width, -0.1 * width);
//     }
//   }
//   {
//     const kigou = ":";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(90, 1, 2, -0.5 * width, -0.1 * width);
//     }
//   }
//   {
//     const kigou = "·“'`”‘’";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(0, 0, 0, 0.3 * width, 0);
//     }
//   }
//   {
//     const kigou = "/\\＿";
//     if (kigou.indexOf(text) !== -1) {
//       return new charPosition(90, 0, 2, -0.8 * width, -0.1 * width);
//     }
//   }
//   return new charPosition(0, 0, 0, 0, 0);
// }
function fontSetting(context, mode) {
    var fontText = "";
    switch (mode) {
        // タイトル
        case 0:
            fontText += "400 60px ";
            break;
        // 文字
        case 1:
            fontText += "400 48px ";
            break;
        // 付記・詞書
        case 2:
            fontText += "400 36px ";
            break;
    }
    if (context !== null) {
        context.font = fontText + getCheckedFont();
    }
}
function getCheckedFont() {
    var fontInputs = [
        "roundedmplus1c",
        "notosansjapanese",
        "lineseed",
        "rocknroll",
        "zenAntique",
        "kiwiMaru",
        "mochiyPop",
        "dotGothic16",
        "kaiseiDecol",
        "zenKurenaido",
        "yuseiMagic",
        "delaGothicOne",
        "hachiMaruPop",
        "zenKakuGothicNew",
        "ShipporiMincho",
        "PottaOne",
        "KleeOne",
        "Stick",
        "HinaMincho",
        "SawarabiMincho",
        "SawarabiGothic",
    ];
    for (var _i = 0, fontInputs_1 = fontInputs; _i < fontInputs_1.length; _i++) {
        var input = fontInputs_1[_i];
        var checkbox = document.querySelector(".".concat(input));
        if (checkbox.checked) {
            switch (input) {
                case "roundedmplus1c":
                    return '"M PLUS Rounded 1c"';
                case "notosansjapanese":
                    return '"Noto Sans JP"';
                case "lineseed":
                    return "'lineseed'";
                case "rocknroll":
                    return "'RocknRoll One'";
                case "zenAntique":
                    return "'Zen Antique'";
                case "kiwiMaru":
                    return "'Kiwi Maru'";
                case "mochiyPop":
                    return "'Mochiy Pop One'";
                case "dotGothic16":
                    return "'DotGothic16'";
                case "kaiseiDecol":
                    return "'Kaisei Decol'";
                case "zenKurenaido":
                    return "'Zen Kurenaido'";
                case "yuseiMagic":
                    return "'Yusei Magic'";
                case "delaGothicOne":
                    return "'Dela Gothic One'";
                case "hachiMaruPop":
                    return "'Hachi Maru Pop'";
                case "zenKakuGothicNew":
                    return "'Zen Kaku Gothic New'";
                case "ShipporiMincho":
                    return "'Shippori Mincho'";
                case "PottaOne":
                    return "'Potta One'";
                case "KleeOne":
                    return "'Klee One'";
                case "Stick":
                    return "'Stick'";
                case "HinaMincho":
                    return "'Hina Mincho'";
                case "SawarabiMincho":
                    return "'Sawarabi Mincho'";
                case "SawarabiGothic":
                    return "'Sawarabi Gothic'";
            }
        }
    }
    return "";
}
function drawCanvas() {
    changeCanvasSize();
    var canvas = document.getElementById("canvas");
    var context = canvas.getContext("2d");
    if (!context) {
        return;
    }
    var color = getSelectedCanvasColor();
    //background color
    context.fillStyle = color;
    context.fillRect(0, 0, canvas.width, canvas.height);
    var displayElem = document.getElementsByClassName("js_display")[0];
    displayElem.style.fontFamily = getCheckedFont();
    var title = document.getElementsByClassName("js_input-text")[0];
    var text = document.getElementsByClassName("js_input-text")[1];
    var note1 = document.getElementsByClassName("js_input-text")[2];
    var note2 = document.getElementsByClassName("js_input-text")[3];
    tategaki(context, title.value, text.value, note1.value, note2.value, canvas.width, canvas.height);
}
var tategaki = function (context, title, text, note1, note2, x, y) {
    // タイトル出力
    {
        var titleList = title.split("\n");
        // フォント設定
        fontSetting(context, 0);
        var lineWidth = context.measureText("あ").width;
        // タイトル
        var text_1 = titleList[0];
        var start_index_1_1 = -1;
        var start_index_2_1 = -1;
        for (var i = 0; i < text_1.length; i++) {
            var char = text_1.charAt(i);
            if (char === "*") {
                if (text_1.substring(i, i + 3) === "***") {
                    if (start_index_1_1 === -1) {
                        start_index_1_1 = i;
                    }
                    else {
                        start_index_2_1 = i - 4;
                        break;
                    }
                }
            }
        }
        if (text_1.indexOf("***") !== -1)
            text_1 = text_1.replace(/\*/g, "");
        var drawX = x * 0.1;
        var drawY = y * 0.15;
        Array.prototype.forEach.call(text_1, function (ch, j) {
            // Canvasの文字色設定
            if (start_index_1_1 == -1 ||
                j < start_index_1_1 ||
                (start_index_2_1 != -1 && start_index_2_1 < j))
                context.fillStyle = getSelectedMainStrColor();
            else
                context.fillStyle = getSelectedSubStrColor();
            context.fillText(ch, drawX + j * lineWidth, drawY);
        });
    }
    // 付記1出力
    {
        var noteList = note1.split("\n");
        // フォント設定
        fontSetting(context, 2);
        var lineWidth = context.measureText("あ").width;
        var text_2 = noteList[0];
        var start_index_1_2 = -1;
        var start_index_2_2 = -1;
        for (var i = 0; i < text_2.length; i++) {
            var char = text_2.charAt(i);
            if (char === "*") {
                if (text_2.substring(i, i + 3) === "***") {
                    if (start_index_1_2 === -1) {
                        start_index_1_2 = i;
                    }
                    else {
                        start_index_2_2 = i - 4;
                        break;
                    }
                }
            }
        }
        if (text_2.indexOf("***") !== -1)
            text_2 = text_2.replace(/\*/g, "");
        Array.prototype.forEach.call(text_2, function (ch, j) {
            // Canvasの文字色設定
            if (start_index_1_2 == -1 ||
                j < start_index_1_2 ||
                (start_index_2_2 != -1 && start_index_2_2 < j))
                context.fillStyle = getSelectedMainStrColor();
            else
                context.fillStyle = getSelectedSubStrColor();
            var drawX = x * 0.95 - text_2.length * lineWidth;
            var drawY = y * 0.95;
            context.fillText(ch, drawX + j * lineWidth, drawY);
        });
    }
    // 付記2出力
    {
        var noteList = note2.split("\n");
        // フォント設定
        fontSetting(context, 2);
        var lineWidth = context.measureText("あ").width;
        // タイトル
        var text_3 = noteList[0];
        var start_index_1_3 = -1;
        var start_index_2_3 = -1;
        for (var i = 0; i < text_3.length; i++) {
            var char = text_3.charAt(i);
            if (char === "*") {
                if (text_3.substring(i, i + 3) === "***") {
                    if (start_index_1_3 === -1) {
                        start_index_1_3 = i;
                    }
                    else {
                        start_index_2_3 = i - 4;
                        break;
                    }
                }
            }
        }
        if (text_3.indexOf("***") !== -1)
            text_3 = text_3.replace(/\*/g, "");
        Array.prototype.forEach.call(text_3, function (ch, j) {
            // Canvasの文字色設定
            if (start_index_1_3 == -1 ||
                j < start_index_1_3 ||
                (start_index_2_3 != -1 && start_index_2_3 < j))
                context.fillStyle = getSelectedMainStrColor();
            else
                context.fillStyle = getSelectedSubStrColor();
            var drawX = (x - lineWidth * (text_3.length - 0)) / 2;
            var drawY = y * 0.95;
            context.fillText(ch, drawX + j * lineWidth, drawY);
        });
    }
    // 本文出力
    {
        var textList = text.split("\n");
        // フォント設定
        fontSetting(context, 1);
        var lineWidth = context.measureText("あ").width;
        // Canvasの縦サイズ・文章の行数による描画開始位置Xの調整
        var startX = y / 2 - lineWidth - (textList.length * lineWidth) / 2;
        // Canvasの横サイズ・文章の長さによる描画開始位置Yの調整調整（詞書は除く）
        var text = "";
        var maxLength = 0;
        textList.forEach(function (elm, i) {
            if (elm.indexOf(kotobagaki) === -1) {
                text = textList[i];
                if (text.indexOf(kotobagaki) !== -1) {
                    text = text.replace("詞書：", "");
                }
                if (text.indexOf("***") !== -1) {
                    text = text.replace(/\*/g, "");
                }
                if (maxLength < text.length) {
                    maxLength = text.length;
                }
            }
        });
        var startY = (x - lineWidth * (maxLength - 0)) / 2;
        textList.forEach(function (elm, i) {
            fontSetting(context, 1);
            var text = elm;
            var start_index_1 = -1;
            var start_index_2 = -1;
            for (var i_1 = 0; i_1 < text.length; i_1++) {
                var char = text.charAt(i_1);
                if (char === "*") {
                    if (text.substring(i_1, i_1 + 3) === "***") {
                        if (start_index_1 === -1) {
                            start_index_1 = i_1;
                        }
                        else {
                            start_index_2 = i_1 - 4;
                            break;
                        }
                    }
                }
            }
            var lineWidthA = lineWidth;
            if (start_index_1 != -1)
                elm = elm.replace(/\*/g, "");
            if (text.indexOf(kotobagaki) !== -1) {
                // 詞書用フォント設定
                fontSetting(context, 2);
                elm = elm.replace("詞書：", "");
                lineWidthA = context.measureText("あ").width;
                if (start_index_1 != -1) {
                    start_index_1 -= 3;
                    start_index_2 -= 3;
                }
            }
            Array.prototype.forEach.call(elm, function (ch, j) {
                // Canvasの文字色設定
                if (start_index_1 == -1 ||
                    j < start_index_1 ||
                    (start_index_2 != -1 && start_index_2 < j)) {
                    context.fillStyle = getSelectedMainStrColor();
                }
                else {
                    context.fillStyle = getSelectedSubStrColor();
                }
                context.fillText(ch, lineWidthA * j + startY, startX + lineWidth * i);
            });
        });
    }
};
function changeCanvasSize() {
    var canvas = document.getElementById("canvas");
    if (!canvas) {
        return;
    }
    var canvasSize = getCanvasSize();
    canvas.setAttribute("width", canvasSize.width.toString());
    canvas.setAttribute("height", canvasSize.height.toString());
}
function getCanvasSize() {
    var yokonaga1 = document.querySelector(".yokonaga1");
    var masikaku = document.querySelector(".masikaku");
    var matiuke = document.querySelector(".matiuke");
    if (masikaku === null || masikaku === void 0 ? void 0 : masikaku.checked) {
        return { width: 2000, height: 2000 };
    }
    else if (matiuke === null || matiuke === void 0 ? void 0 : matiuke.checked) {
        return { width: 2000, height: 4000 };
    }
    else {
        // デフォルト値を返す
        return { width: 2000, height: 1500 };
    }
}
function check2Color(radioButtons) {
    var colors = {
        siro: "#ffffff",
        koniro: "#223a70",
        aiiro: "#165e83",
        enjiiro: "#b94047",
        fujiiro: "#bbbcde",
        azukiiro: "#96514d",
        sakurairo: "#fef4f4",
        momoiro: "#f09199",
        nezumiiro: "#949495",
        syuiro: "#ba2636",
        kuro: "#000000",
        picker: "picker",
    };
    for (var i = 0; i < radioButtons.length; i++) {
        var radioButton = radioButtons[i];
        if (radioButton.checked) {
            var propertyName = Object.keys(colors)[i]; // プロパティ名を取得
            return colors[propertyName];
        }
    }
    return "";
}
function getSelectedCanvasColor() {
    var radioButtons = document.getElementsByName("c_color");
    var color = check2Color(radioButtons);
    if (color === "picker") {
        var title = (document.getElementsByClassName("c_picker")[0]);
        return title.value;
    }
    return color;
}
function getSelectedMainStrColor() {
    var radioButtons = document.getElementsByName("ms_color");
    var color = check2Color(radioButtons);
    if (color === "picker") {
        var title = (document.getElementsByClassName("ms_picker")[0]);
        return title.value;
    }
    return color;
}
function getSelectedSubStrColor() {
    var radioButtons = document.getElementsByName("ss_color");
    var color = check2Color(radioButtons);
    if (color === "picker") {
        var title = (document.getElementsByClassName("ss_picker")[0]);
        return title.value;
    }
    return color;
}
function insertText() {
    var inputTextElements = document.getElementsByClassName("js_input-text");
    var inputText = inputTextElements[1];
    var text = inputText.value;
    text += "\n詞書：";
    inputText.value = text;
}
function registerButtonEvent(selector, callback) {
    var button = document.querySelector(selector);
    button.addEventListener("click", callback);
}
document.addEventListener("DOMContentLoaded", function () {
    registerButtonEvent(".js_downloadButton", downloadCardImage);
    registerButtonEvent(".js_insertButton", insertText);
    // registerButtonEvent('.js_tweetButton', tweet);
    var textareas = document.querySelectorAll(".js_input-text");
    textareas.forEach(function (areas) {
        areas.addEventListener("input", function () {
            genereteCardImage();
        });
    });
    var radioFontInputs = document.querySelectorAll('input[type="radio"][name="font"]');
    radioFontInputs.forEach(function (fontInput) {
        fontInput.addEventListener("change", function () {
            genereteCardImage();
        });
    });
    var radioSizeInputs = document.querySelectorAll('input[type="radio"][name="size"]');
    radioSizeInputs.forEach(function (sizeInput) {
        sizeInput.addEventListener("change", function () {
            genereteCardImage();
        });
    });
    var radioCColorInputs = document.querySelectorAll('input[type="radio"][name="c_color"]');
    radioCColorInputs.forEach(function (ccolorInput) {
        ccolorInput.addEventListener("change", function () {
            genereteCardImage();
        });
    });
    var radioMsColorInputs = document.querySelectorAll('input[type="radio"][name="ms_color"]');
    radioMsColorInputs.forEach(function (mscolorInput) {
        mscolorInput.addEventListener("change", function () {
            genereteCardImage();
        });
    });
    var radioSsColorInputs = document.querySelectorAll('input[type="radio"][name="ss_color"]');
    radioSsColorInputs.forEach(function (sscolorInput) {
        sscolorInput.addEventListener("change", function () {
            genereteCardImage();
        });
    });
    var colorPicker1 = document.querySelector(".c_picker");
    if (colorPicker1) {
        colorPicker1.addEventListener("change", function (event) {
            var selectedRadio = document.querySelector("input[type=\"radio\"][class=\"picker\"][name=\"c_color\"]");
            if (selectedRadio) {
                selectedRadio.checked = true;
            }
            genereteCardImage();
        });
    }
    var colorPicker2 = document.querySelector(".ms_picker");
    if (colorPicker2) {
        colorPicker2.addEventListener("change", function (event) {
            var selectedRadio = document.querySelector("input[type=\"radio\"][class=\"picker\"][name=\"ms_color\"]");
            if (selectedRadio) {
                selectedRadio.checked = true;
            }
            genereteCardImage();
        });
    }
    var colorPicker3 = document.querySelector(".ss_picker");
    if (colorPicker3) {
        colorPicker3.addEventListener("change", function (event) {
            var selectedRadio = document.querySelector("input[type=\"radio\"][class=\"picker\"][name=\"ss_color\"]");
            if (selectedRadio) {
                selectedRadio.checked = true;
            }
            genereteCardImage();
        });
    }
});
